'use strict';

const { Component } = require('phy');
const { h } = require('phy');

const { experiments } = require('../../modules/support/experiment-data');

function triggerSuccess(experimentName) {
  if (experiments[experimentName]) {
    const { customMetric } = experiments[experimentName];

    if (customMetric) {
      window.OptimizeSuite.InteractionGoals.successMetric({
        type: customMetric,
        channel: 'coupons',
      });
    }
  }
}

function clickHandler(previousOnClick, experimentName) {
  if (typeof previousOnClick === 'function') {
    previousOnClick();
  }

  triggerSuccess(experimentName);
}

class Link extends Component {
  constructor(props) {
    super(props);
  }

  render() {
    const {
      className = '',
      experimentName,
      attributes,
      text = '',
    } = this.props;

    const previousOnClick = attributes.onClick;

    attributes.onClick = () => clickHandler(previousOnClick, experimentName);

    return h(`a.${className}`, attributes, text);
  }
}

module.exports = Link;
